export default __webpack_public_path__ + "static/media/help8.dc53a107.svg";